import React from 'react'
import { Link } from 'react-router-dom'
import { Flex, Button, Box, Skeleton, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { keyframes } from 'styled-components'
import Balance from 'components/Balance'
import { usePriceATALIRABusd, usePricebabyBusd, usePriceBnbBusd, usePricebuildBusd, usePriceBVCBusd, usePriceCakeBusd, usePriceETCBusd, usePriceETHBusd, usePriceEXZOBusd, usePriceHVIBusd, usePriceLameaBusd, usePriceLGCBusd, usePriceliraBusd, usePriceLTCBusd, usePriceskeletonBusd, usePricetripBusd } from 'state/farms/hooks'
import RowHeading from './RowHeading'

const Container = styled.div`
height: 25px;
width: 100%;
overflow: hidden;
position: relative;
margin-bottom: 20px;
margin-top: -20px;
justify-content: space-between;
  ${({ theme }) => theme.mediaQueries.md} {
    border-radius: 8px;
    height: 25px;
    margin-bottom: 20px;
    overflow: hidden;
    margin-top: -20px;
    width: 100%;
    position: relative;
    justify-content: space-between;
  }
`


const ImageWrapper = styled.div`
flex: none;
margin: 0 auto;
margin-right: 5px;
${({ theme }) => theme.mediaQueries.md} {
  flex: none;
  margin: 0 auto;
  margin-right: 5px;

}
`
const floatingAnim = (x: string, y: string) => keyframes`
0% {transform: translate3d(0px, 0%, 0px);}
32.9999% {transform: translate3d(0px, 0%, 0px);}
33% {transform: translate3d(0px, -25px, 0px);}
66.9999% {transform: translate3d(0px, -25px, 0px);}
67% {transform: translate3d(0px, -50px, 0px);}
100% {transform: translate3d(0px, -50px, 0px);}
`
const floatingAnim2 = (x: string, y: string) => keyframes`
0% {transform: translate3d(0px, 0%, 0px);}
10% {transform: translate3d(0px, 0%, 0px);}
32.9999% {transform: translate3d(0px, 0%, 0px);}
33% {transform: translate3d(0px, -50px, 0px);}
43% {transform: translate3d(0px, -50px, 0px);}
65.99999% {transform: translate3d(0px, -50px, 0px);}
66% {transform: translate3d(0px, -100px, 0px);}
100% {transform: translate3d(0px, -100px, 0px);}
`

const Wrapper = styled(Box)`
position: relative;
animation: ${floatingAnim('3px', '15px')} 5s linear infinite;
  animation-delay: 0s;
  ${({ theme }) => theme.mediaQueries.xs} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 5s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 5s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.md} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 5s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.xl} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 5s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 5s linear infinite;
      animation-delay: 0s;  
  }
`
const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`


interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
}

const TopTokenMovers3: React.FC= () => {
  const { t } = useTranslation()
  const bnbprice0 = usePriceBnbBusd()
  const bnbprice = bnbprice0.toNumber()
  const lameaprice0 = usePriceLameaBusd()
  const lameaprice = lameaprice0.toNumber()
  const ehtprice0 = usePriceETHBusd()
  const ethprice = ehtprice0.toNumber()
  const lgcprice0 = usePriceLGCBusd()
  const lgcprice = lgcprice0.toNumber()
  const etcprice0 = usePriceETCBusd()
  const etcprice = etcprice0.toNumber()
  const ltcprice0 = usePriceLTCBusd()
  const ltcprice = ltcprice0.toNumber()
  const bvcprice0 = usePriceBVCBusd()
  const bvcprice = bvcprice0.toNumber()
  const buildprice0 = usePricebuildBusd()
  const buildprice = buildprice0.toNumber()
  const liraprice0 = usePriceliraBusd()
  const liraprice  = liraprice0.toNumber()
 const vizslaprice = usePriceCakeBusd()
 const vizslaprice0 = vizslaprice.toNumber()
 const exzoprice0 = usePriceEXZOBusd()
 const exzoprice = exzoprice0.toNumber()
 const ataliraprice0 = usePriceATALIRABusd()
 const ataliraprice = ataliraprice0.toNumber()
 const tripprice0 = usePricetripBusd()
 const tripprice = tripprice0.toNumber()
 const skeletonprice0 = usePriceskeletonBusd()
 const skeletonprice = skeletonprice0.toNumber()
 const babyprice0 = usePricebabyBusd()
 const babyprice = babyprice0.toNumber()

  return (
    
    <Container>
      
      <Flex justifyContent="center" alignItems="center">
      <Wrapper>

<Flex flexDirection="column" alignItems="center" >
                      <Flex justifyContent="center" alignItems="center">

                             <RowHeading text={ t('Trade')} mt="4px" />
                             </Flex >
                             </Flex>

                             <Flex flexDirection="column" alignItems="center" >
                      <Flex justifyContent="center" alignItems="center">

                             <RowHeading text={ t('Trade Stake')} mt="4px" />
                             </Flex >
                             </Flex>

                             <Flex flexDirection="column" alignItems="center" >
                      <Flex justifyContent="center" alignItems="center">

                             <RowHeading text={ t('Trade Stake Earn')} mt="4px" />
                             </Flex >
                             </Flex>
      </Wrapper>
      </Flex>

      </Container>
  )
}

export default TopTokenMovers3
